module.exports = __webpack_public_path__ + "img/progress-bg.1977b970.png";